<template>
  <div id="inspectionReport" style="position: relative">
    <div class="inspectionReport-main">
      <div class="inspectionReport-main-top">
        <img src="../../../../public/img/stepIcon.png">
        <div class="inspectionReport-main-top-name">
          <div style="font-size: 30px">原材料检验记录</div>
          <div style="font-size: 25px">Raw material inspection record</div>
        </div>
        <div class="inspectionReport-main-top-right">
          <div style="display: flex;flex-direction: row;align-items: center;border-bottom: 1px solid #333333;height: 33px">
            <div style="margin-left: 3px">版本Ver：A</div>
            <div style="margin-left: 50px">修订Rev：1</div>
          </div>
          <div style="padding-left: 3px;border-bottom: 1px solid #333333;height: 33px;line-height: 33px">STEP/R-DQ-QD-039-01</div>
          <div style="padding-left: 3px;height: 33px;line-height: 33px">编号Code：</div>
        </div>
      </div>
      <div class="inspectionReport-main-wl">
        <el-form
            ref="form"
            :model="inspectionReport"
            class="form"
            label-width="220px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="物料凭证号 Material voucher No：">
                <el-input v-model="inspectionReport.voucherNo" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料代码 Material code：">
                <el-input v-model="inspectionReport.materialNo" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料名称 Material name：">
                <el-input v-model="inspectionReport.materialName" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="规格型号 Specification：">
                <el-input v-model="inspectionReport.materialName"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="供应商 Supplier：">
                <el-input v-model="inspectionReport.supplierName" placeholder="请选择" readonly>
                  <el-button slot="append" icon="el-icon-search" @click="$refs.selectSupplierManage.open()"/>
                </el-input>
                <supplier-manage-select ref="selectSupplierManage" @select="onSelectSupplier"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="送检总数 Total inspecting Qty：">
                <el-input v-model="inspectionReport.submissionNum"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="抽检数 Sample Qty：">
                <el-input v-model="inspectionReport.spotCheckNum"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="不合格数 Unqualified Qty：">
                <el-input v-model="inspectionReport.unqualifiedNum"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="检验日期 Inspection date：">
                <el-date-picker
                    v-model="inspectionReport.createdTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    placeholder="选择日期"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="margin: 0 0 5px 5px">
          <el-button type="primary" @click="addItem()">添加</el-button>
        </div>
      </div>
      <div class="inspectionReport-main-table">
        <table cellpading="0" cellspacing="0" style="width: 100%;height: 100%">
          <tr>
            <td rowspan="2">检查项目Inspection items</td>
            <td rowspan="2">标准 Standard</td>
            <td colspan="14">检验序号Inspection sequence No.</td>
          </tr>
          <tr>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
            <td>6</td>
            <td>7</td>
            <td>8</td>
            <td>9</td>
            <td>10</td>
            <td>11</td>
            <td>12</td>
            <td>13</td>
            <td>操作</td>
          </tr>
          <tr v-for="(item, index) in inspectionReport.rawMaterialInspections" :key="index">
            <td><el-input v-model="item.inspectionItem" placeholder="请输入"/></td>
            <td><el-input v-model="item.standard" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort1" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort2" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort3" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort4" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort5" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort6" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort7" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort8" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort9" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort10" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort11" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort12" placeholder="请输入"/></td>
            <td><el-input v-model="item.inspectionSort13" placeholder="请输入"/></td>
            <td><el-button type="danger" @click="oneDelete(index)">删除</el-button></td>
          </tr>
          <tr>
            <td colspan="2">器具名称</td>
            <td colspan="14">
              <el-radio-group v-model="inspectionReport.appliance">
                <el-radio :label="1">A 卡尺</el-radio>
                <el-radio :label="2">B 卷尺</el-radio>
                <el-radio :label="3">C 涂层测厚仪</el-radio>
                <el-radio :label="4">D 万用表</el-radio>
                <el-radio :label="5">F 绝缘耐压测试仪</el-radio>
                <el-radio :label="6">G 色差仪</el-radio>
                <el-radio :label="7">H 含水量测定仪</el-radio>
                <el-radio :label="8">I 透光度测量仪</el-radio>
                <el-radio :label="9">J 塞尺</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <td colspan="2">样品判定 Sample defined</td>
            <td colspan="14">
              <el-input v-model="inspectionReport.sampleDefined" placeholder="请输入"/>
            </td>
          </tr>
          <tr>
            <td colspan="16">
              <div style="text-align: left;margin: 3px 5px;">整批判定 Whole bulk defined:</div>
              <el-input v-model="inspectionReport.bulkDefined" placeholder="请输入"/>
              <div style="text-align: right;margin: 3px 150px 3px 5px">检验员 Inspector:</div>
            </td>
          </tr>
          <tr>
            <td colspan="16">
              <div style="text-align: left;;margin: 3px 5px;">备注 Remark:</div>
              <el-input type="note" placeholder="请输入"/>
            </td>
          </tr>
        </table>
      </div>
      <div class="inspectionReport-main-bottom">
        <div style="margin-left: 20px">
          <div>适用公司：电气</div>
          <div>Application：DQ</div>
        </div>
        <div style="margin-right: 20px">
          <div>保存期限：10年</div>
          <div>Preservationg：10 years</div>
        </div>
      </div>
    </div>
    <div slot="footer" style="position: absolute;bottom: -35px;right: 5%">
      <el-button :loading="saveLoading" type="primary" @click="rawMaterialSave">保存</el-button>
    </div>
  </div>
</template>

<script>
  import SupplierManageSelect from "@/views/information/SupplierManage/SupplierManageSelect";

  export default {
    name:"",
    components: {SupplierManageSelect},
    data() {
      return {
        saveLoading:false,
        inspectionReportId:"",
        inspectionReport: {},
      };
    },
    mounted() {
      this.inspectionReportId = this.$route.params.id;
      if (this.inspectionReportId>0) {
        this.getData(this.inspectionReportId);
      }else {
        this.$message.error("获取失败原材料信息失败");
        // console.log(this.$route);
        // this.inspectionReport = this.$route.query.inspectionReport;
      }
    },
    methods: {
      getData(id) {
        this.contentLoading = true;
        this.$http
          .get("basic", `inspectionReports/selectReportByPKID/${id}`)
          .then(resp => {
            console.log(resp);
            this.inspectionReport = resp;
          });
      },
      onSelectSupplier(row) {
        this.inspectionReport.supplierID = row.pkid;
        this.inspectionReport.supplierName = row.name;
      },
      rawMaterialSave() {
        this.saveLoading = true;
        this.$http
          .post("basic", "inspectionReports/rawMaterial_save", this.inspectionReport)
          .then(() => {
            this.saveLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("保存成功");
          })
          .catch(() => {
            this.saveLoading = false;
          });
      },
      addItem() {
        let params = {
          pkid:null,
          inspectionItem:"",
          inspectionSort1:"",
          inspectionSort2:"",
          inspectionSort3:"",
          inspectionSort4:"",
          inspectionSort5:"",
          inspectionSort6:"",
          inspectionSort7:"",
          inspectionSort8:"",
          inspectionSort9:"",
          inspectionSort10:"",
          inspectionSort11:"",
          inspectionSort12:"",
          inspectionSort13:"",
        };
        this.inspectionReport.rawMaterialInspections.push(params);

      },
      oneDelete(index){
        this.inspectionReport.rawMaterialInspections.splice(index, 1);
      },
      print() {
        document.body.innerHTML = document.getElementById("inspectionReport").innerHTML;
        window.print();
        window.location.reload();
        return false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  #inspectionReport{
    .inspectionReport-main{
      border: 1px solid #333333;
      width: 90%;
      margin: 0 auto;
      .inspectionReport-main-top{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #333333;
        img{
          width: 300px;
          height: 100px;
          border-right: 1px solid #333333;
        }
        .inspectionReport-main-top-name{
          text-align: center;


        }
        .inspectionReport-main-top-right{
          width: 300px;
          height: 100px;
          border-left: 1px solid #333333;
        }
      }
      .inspectionReport-main-wl{
        padding-top: 10px;
        border-bottom: 1px solid #333333;
      }
      .inspectionReport-main-table{
        table{
          tr{
            td{
              border-bottom: 1px solid #333333;
              border-left: 1px solid #333333;
              text-align: center;
            }
          }
        }
      }
      .inspectionReport-main-bottom{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #333333;
        margin-top: 10%;
        margin-bottom: 5px;
      }
    }
  }
</style>
